


































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IContract, IContractProduct } from "@/models/contracts";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "provision-requests-provider": () =>
      import(
        "@/components/app/admin/provisioning/provisionRequestsProvider.vue"
      ),
    "provision-requests-table-view": () =>
      import(
        "@/components/app/admin/provisioning/provisionRequestsTableView.vue"
      )
  }
})
export default class ProvisionRequestsListing extends Vue {
  // Props

  @Prop({ default: "PRLP1" /** [P]rovision [R]equests [L]ist [P]rovider */ })
  public declare id: string;

  @Prop({ default: undefined })
  public contractId!: IContract["id"];

  @Prop({ default: undefined })
  public productId!: IContractProduct["id"];

  @Prop({ default: 12 })
  public declare limit: number;

  @Prop({ default: "" })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public withClientFilters!: number;

  @Prop({ default: false })
  public isStaged!: boolean;

  @Prop({ default: true })
  public routeOpening!: boolean;
}
